module.exports = __webpack_public_path__ + "static/media/financial icon 3.7d16ecb6.png";